import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sizeCtrl",
  "use": "sizeCtrl-usage",
  "viewBox": "0 0 20 17.09",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 17.09\" id=\"sizeCtrl\"><title>sizeCtrl</title><path d=\"M19 12.19H7.38a1.09 1.09 0 0 1 0-2.18H19a1.09 1.09 0 0 1 0 2.18zm0-5.09H7.38a1.09 1.09 0 0 1 0-2.18H19a1.09 1.09 0 0 1 0 2.18zm-.09-4.91H1.09a1.09 1.09 0 0 1 0-2.18h17.82a1.09 1.09 0 0 1 0 2.18zM5.09 12.18L0 8.54l5.09-3.63v7.27zm-4 2.73h17.82a1.09 1.09 0 0 1 0 2.18H1.09a1.09 1.09 0 0 1 0-2.18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/sizeCtrl.svg
// module id = ribp
// module chunks = 6